
<template>
  <div>
    <h1>{{name}}</h1>

    <h4>Klassen</h4>
    <ul>
      <li v-for="schoolClass in classes" :key="schoolClass.$id">
        <router-link
          v-bind:to="/schule/ + $route.params.id + /klasse/ +schoolClass.$id"
          class="nav-link"
        >{{ schoolClass.name }}</router-link>
      </li>
    </ul>

    <router-link v-bind:to="/schule/ + $route.params.id + /bibliothek/">
      <button class="btn btn-primary btn-margin">Bibliothek öffnen</button>
    </router-link>
  </div>
</template>

<script>
import { fetchSchool, fetchClassesOfSchool } from "../firebase/firebase";
export default {
  name: "school",
  data() {
    return {
      unsubscribe: null,
      unsubscribeClasses: null,
      name: "",
      classes: []
    };
  },
  created() {
    this.unsubscribe = fetchSchool(this.$route.params.id).onSnapshot(
      onSnapshot => {
        const $data = onSnapshot.data();
        this.name = $data.name;
      }
    );
    this.unsubscribeClasses = fetchClassesOfSchool(
      this.$route.params.id
    ).onSnapshot(querySnapshot => {
      this.classes = querySnapshot.docs.map(doc => {
        const $data = doc.data();
        return {
          $id: doc.id,
          ...$data
        };
      });
    });
  },
  destroyed() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    if (this.unsubscribeClasses) {
      this.unsubscribeClasses();
    }
  }
};
</script>